import React from 'react'
import Card from '../Components/Common/Card'
import UsersGrid from '../Components/User/UsersGrid'
import './Styles/UserManagement.css';

const UsersManagement = () => {
    return (
        <section className='users'>
            <Card options={{}}>
                <UsersGrid/>
            </Card>
        </section>
    )
}

export default UsersManagement